import { type Permission, hasAnyPermission, hasPermission } from '@/lib/rbac';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Hook to check current user's permissions.
 */
export function usePermission(permission: Permission): boolean {
  const role = useAuthStore(s => s.user?.role);
  return hasPermission(role, permission);
}

/**
 * Hook to check if user has any of the given permissions.
 */
export function useAnyPermission(permissions: Permission[]): boolean {
  const role = useAuthStore(s => s.user?.role);
  return hasAnyPermission(role, permissions);
}

/**
 * Hook to get a permission checker function.
 */
export function usePermissions() {
  const role = useAuthStore(s => s.user?.role);
  return {
    can: (permission: Permission) => hasPermission(role, permission),
    canAny: (permissions: Permission[]) => hasAnyPermission(role, permissions),
    role,
  };
}
